import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function About() {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px - 120px)',
        backgroundColor: '#F5F9FF',
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2rem', md: '2.5rem' },
            fontWeight: 700,
            color: '#1A237E',
            mb: 3,
          }}
        >
          Om oss
        </Typography>

        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Mitt båtliv började i barndomen när jag ibland fick följa med pappa och hans bror ut med deras fina träsnipa. Kanske var det där grunden lades.
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          På 90-talet tog jag och min fru själva över en gammal träsnipa som vi renoverade och tuffade runt med på sjön under flera år. Sedan blev det en större plastbåt med pentry och sovplatser – och våra barn fick tillbringa många somrar till sjöss.
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Efter ungefär tio år med motorbåt väcktes en ny tanke: tänk om vi skulle lära oss segla? Vi gick kurser, köpte en liten segelbåt och började lära oss – med alla tampar, trim och nya begrepp. Ett par segelbåtar senare seglar vi idag en Maxi 33 och njuter varje sommar av flera veckor till havs tillsammans med goda vänner.
        </Typography>

        <Typography variant="h6" component="h2" sx={{ color: '#1A237E', fontWeight: 600, mb: 1.5, mt: 3 }}>
          Idén bakom Seglingssajten
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Jag har länge arbetat med egna webbprojekt och har bland annat byggt <a href="https://familjesajten.se" target="_blank" rel="noopener noreferrer">Familjesajten</a> – en digital plats för att bygga släktträd och bevara släktminnen och berättelser. Under det arbetet växte en ny idé fram:
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2, fontStyle: 'italic' }}>
          Varför finns det ingen enkel, modern och mobilanpassad loggbok för båtägare?
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 1 }}>
          Som båtägare lägger man ner mycket tid på:
        </Typography>
        <Box component="ul" sx={{ color: '#212121', pl: 2.5, mb: 2, mt: 0 }}>
          <li><Typography component="span" variant="body1">service och underhåll</Typography></li>
          <li><Typography component="span" variant="body1">uppgraderingar och förbättringar</Typography></li>
          <li><Typography component="span" variant="body1">planering och dokumentation</Typography></li>
        </Box>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Det är värdefull information – både för dig själv och inför en framtida försäljning. Att kunna visa exakt vad som är gjort, när det gjordes och hur det utfördes skapar trygghet och förtroende.
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 1 }}>
          Samtidigt är båtlivet mer än serviceprotokoll – det är nya hamnar, kvällar i naturhamn, måltider i sittbrunnen, härliga möten med vänner och familj och mycket mer.
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 1 }}>
          Med Seglingssajten kan du:
        </Typography>
        <Box component="ul" sx={{ color: '#212121', pl: 2.5, mb: 2, mt: 0 }}>
          <li><Typography component="span" variant="body1">Dokumentera servicearbeten med bilder och beskrivningar</Typography></li>
          <li><Typography component="span" variant="body1">Föra tripplogg med väder, distans och rutt</Typography></li>
          <li><Typography component="span" variant="body1">Skriva personliga anteckningar om varje tur</Typography></li>
          <li><Typography component="span" variant="body1">Ladda upp bilder och spara minnen</Typography></li>
          <li><Typography component="span" variant="body1">Samla allt på ett ställe – tillgängligt i mobilen eller på datorn</Typography></li>
        </Box>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2, fontWeight: 500 }}>
          En loggbok för både ordning och upplevelse.
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Jag har själv använt Seglingssajten under en tid och nu är det dags att öppna upp den för fler båtägare.
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Varmt välkommen att bli en del av Seglingssajten.
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: '#212121',
            mb: 1,
            fontFamily: '"Dancing Script", cursive',
            fontSize: '1.75rem',
            fontWeight: 600,
          }}
        >
          Tommy Johansson
        </Typography>
        <Typography variant="body1" sx={{ color: '#212121', mb: 4 }}>
          Göteborg, februari 2026
        </Typography>

        <Typography variant="body1" sx={{ color: '#212121', mb: 2 }}>
          Det tar bara någon minut att komma igång.
        </Typography>
        <Button
          component={Link}
          to="/?tab=signup"
          variant="contained"
          sx={{
            backgroundColor: '#1565C0',
            color: '#fff',
            textTransform: 'none',
            '&:hover': { backgroundColor: '#0d47a1' },
          }}
        >
          Börja din loggbok idag
        </Button>
      </Container>
    </Box>
  );
}

export default About;
